<template>
  <form class="nameform" @submit="next">
    <div class="content">
      <h1 class="mb-6 text-center big-title">
        Conferma la richiesta carta
      </h1>

      <p class="text-center">
        Inserisci il tuo codice di accesso
      </p>
      <div class="mt-10">
        <PinCode @onUpdate="v => (pinCode = v)" />
      </div>
    </div>

    <div class="page-footer">
      <button
        class="desktop-only btn"
        :disabled="pinCode.length < 5"
        @click="next"
      >
        Prosegui
      </button>
    </div>
    <NumericPad renderButton="true">
      <button class="btn" :disabled="pinCode.length < 5" type="submit">
        Prosegui
      </button>
    </NumericPad>
  </form>
</template>

<script>
import PinCode from "@/components/PinCode";
import NumericPad from "@/components/NumericPad";
import UtilityService from "@/services/UtilityService";
import RegistrationService from "@/services/RegistrationService";

export default {
  name: "NameForm",
  components: {
    PinCode,
    NumericPad
  },
  props: ["errors", "skipNewToken"],
  data() {
    return {
      pinCode: ""
    };
  },
  mounted() {
    if (this.errors && this.errors.pinCode) {
      UtilityService.showErrorModal(this.errors.pinCode);
    }
    this.$root.$on("openedNumericPad", this.openedNumericPad);
  },
  methods: {
    openedNumericPad() {
      UtilityService.scrollTopPage();
    },
    async next(event) {
      //prevent form submit
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      this.$store.commit("setUser", {
        confirmAccessCode: this.pinCode
      });

      if (!this.skipNewToken) {
        await RegistrationService.sendOtp();
      }

      this.$root.$emit("submitStep");
    }
  }
};
</script>
